import { render, staticRenderFns } from "./BibliaRegistrosRow.vue?vue&type=template&id=ff4a4500"
import script from "./BibliaRegistrosRow.vue?vue&type=script&lang=js"
export * from "./BibliaRegistrosRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports